export default {
  components: {
    View: "View",
    Edit: "Edit"
  }
}
